import { LabelProps, Label } from './Label';
export function LabelDisplay3(props: LabelProps) {
    return <Label color="text-dark-red" variant="text-display-3" {...props} />;
}
